import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { CheckCircle } from 'lucide-react';
import api from '../utils/api';

const CheckoutSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [trialDays, setTrialDays] = useState(15);

  useEffect(() => {
    // Here you could verify the session with your backend if needed
    if (!sessionId) {
      navigate('/pricing');
    }
    api.get('/trial/config')
      .then((res) => setTrialDays(res.data.trial_days))
      .catch(() => {});
  }, [sessionId, navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <Card className="max-w-2xl w-full">
        <CardHeader className="text-center pb-6">
          <div className="mx-auto mb-4 h-16 w-16 rounded-full bg-green-100 flex items-center justify-center">
            <CheckCircle className="h-10 w-10 text-green-600" />
          </div>
          <CardTitle className="text-3xl">Welcome to SlickSignature!</CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-6">
          <div>
            <p className="text-lg text-gray-700 mb-2">
              Your account has been created successfully! 🎉
            </p>
            <p className="text-gray-600">
              Your {trialDays}-day free trial has started. Check your email for login instructions.
            </p>
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 text-left">
            <h3 className="font-semibold text-blue-900 mb-3">What's Next?</h3>
            <ol className="list-decimal list-inside space-y-2 text-sm text-blue-800">
              <li>Check your email for your login credentials</li>
              <li>Sign in to your admin dashboard</li>
              <li>Customize your company's signature template</li>
              <li>Share the signature URL with your team</li>
            </ol>
          </div>

          <div className="space-y-3 pt-4">
            <Button
              onClick={() => navigate('/login')}
              className="w-full py-6 text-lg"
            >
              Go to Login
            </Button>
            
            <p className="text-sm text-gray-500">
              Need help? Contact us at hello@slicksignature.com
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default CheckoutSuccess;
